module.exports = {"data_ver":"数据","app_ver":"App","server":"主机","password":"密码","language":"语言","display":"显示屏","maintain":"维护","inquire":"查询"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/cn.json
// module id = 2fAS
// module chunks = 1